import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { getStartingPrice, formatPrice } from '@/lib/pricing';

export default function ServiceCard({ service }) {
  const startingPrice = getStartingPrice(service.id);
  return (
    <div className="group border border-navy/10 p-8 transition-all hover:border-navy/30 hover:bg-secondary/30 h-full flex flex-col">
      <div className="flex items-start justify-between mb-6">
        <p className="caps-label text-orange">{service.category}</p>
        <ArrowUpRight className="text-navy/30 group-hover:text-orange transition-colors" size={20} />
      </div>
      <h3 className="text-xl font-semibold text-navy mb-3">{service.name}</h3>
      <p className="text-sm text-muted-foreground leading-relaxed mb-6 flex-1">{service.description}</p>
      <div className="flex items-center justify-between mt-auto">
        <div>
          <p className="caps-label text-muted-foreground">From</p>
          <p className="text-2xl font-bold text-navy mono-number">{formatPrice(startingPrice)}</p>
        </div>
        <div className="flex gap-2">
          <Link to={`/request-quote?service=${service.id}`} className="px-4 py-2 bg-white border border-navy/20 text-navy text-xs font-semibold rounded-full hover:border-orange hover:text-orange transition-colors">Quote</Link>
          <Link to={`/book-now?service=${service.id}`} className="px-4 py-2 bg-orange text-navy text-xs font-semibold rounded-full hover:bg-orange-dark transition-colors">Book</Link>
        </div>
      </div>
    </div>
  );
}